import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import StickyBox from 'react-sticky-box';
// import InfiniteScroll from 'react-infinite-scroller';
import parse from 'html-react-parser';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import SEO from 'next-seo.config';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from 'src/components/layouts';
import { APP_IMG, APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { isRender, useDesktop } from 'src/utils/device';
import { rewriteTxt, timestamp } from 'src/utils/helper';
import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';

const PageError = dynamic(import('pages/404'));
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'));
const CardH = dynamic(import('src/components/cards/card-h'));
const CardV = dynamic(import('src/components/cards/card-v'));
const SectionFullH = dynamic(import('src/components/sections/section-full-h'));
const SectionAffiliate = dynamic(import('src/components/sections/section-event/section-affiliate'));
const PageCategory = ({ articles, nextArticles, category, subCategory, lastNews, meta, ads, dataAffiliate, dataAdsHeader, backgroundImage }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (articles === null) {
    return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  }
  const router = useRouter();
  /* -------------------------------- START : LOADMORE -------------------------------- */
  const nextLinkRef = useRef(nextArticles);
  const listArticlesRef = useRef(articles);
  const [listArticles, setListArticles] = useState(articles);
  const [show, setShow] = useState(12);
  const [adsBox, setAdsBox] = useState(true);
  const [isLoad, setIsLoad] = useState(true);
  const [loadData, setLoadData] = useState(false);
  const handleLightBoxClick = () => {
    setAdsBox(false);
  };
  const handleLoad = async () => {
    setLoadData(true);
    try {
      if (nextArticles && isLoad) {
        const resData = await GET_ARTICLES(`${nextLinkRef.current || ''}`, false, true);
        // console.log(`${nextLinkRef.current}${convertObjPath({ limit: 20 })}`)
        if (!_.isEmpty(resData?.data)) {
          nextLinkRef.current = resData?.nextTo || resData?.links?.next;
          const newLists = [...listArticlesRef.current, ...resData?.data];
          listArticlesRef.current = _.uniqBy(newLists, 'id');
          setListArticles(listArticlesRef.current);
        }
      }
      setShow(show + 12);
      setIsLoad(!isLoad);
    } catch (err) {
      console.error(`${timestamp()} ==========> LOAD_CATEGORY_LIST ERROR : ${nextLinkRef?.current}`, err);
    }
    setLoadData(false);
  };
  const cloneListArticles = [...listArticles];
  // console.log({ cloneListArticles, articles });
  const onTopArticle = cloneListArticles.splice(0, 5);

  let baseUrlCategory = `${APP_URL}/category/${category?.en}`;
  const _article = {
    title: meta?.title || WEB_TITLE,
    description: meta?.description || WEB_DESC,
    keyword: meta?.keyword || WEB_KEYWORD
  };

  let setItemListElement = '';

  if (subCategory?.en) {
    baseUrlCategory = `${APP_URL}/category/${category?.en}/${subCategory?.en}`;
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "${category?.th}",
        "item": "${APP_URL}/category/${category?.en}"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "${subCategory?.th}",
        "item": "${baseUrlCategory}"
      }
    ]`;
  } else {
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "${category?.th}",
          "item": "${APP_URL}/category/${category?.en}"
        }
      ]`;
  }

  // const { sub } = router.query;
  // const adsPremiumList = ['business'];
  // const adsFinanceList = ['business_finance'];
  // const adsEducationList = ['social_education'];
  // const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });

  // console.log(nextLinkRef);
  // const titleEscape = escapeChar(meta.title);
  const categoryNameTH = subCategory?.th ? subCategory?.th : category?.th;

  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        {...SEO}
        title={_article?.title}
        description={_article?.description}
        openGraph={{
          ...SEO.openGraph,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title} />
        <meta property='twitter:description' content={_article?.description} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />

        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                 __th_page="${subCategory?.en ? subCategory.en : category?.en}";
            `
          }}
        />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* ---------------------------- SPIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "${WEB_NAME}",
                "url": "${WEB_URL.WEB}",
                "description": "${_article?.description}",
                "sameAs": [
                  "${WEB_URL.FACEBOOK}",
                  "${WEB_URL.TWITTER}",
                  "${WEB_URL.INSTAGRAM}",
                  "${WEB_URL.YOUTUBE}",
                  "${WEB_URL.LINE}"
                ],
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "${WEB_URL.WEB}search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            `
          }}
        />

        {/* ---------------------------- SPIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "http://schema.org",
                  "@type": "WebPage",
                  "name": "${categoryNameTH}",
                  "description": "${_article?.description}",
                  "publisher": {
                    "@type": "ProfilePage",
                    "name": "${WEB_NAME}"
                  }
                }
              `
          }}
        />

        {/* ------------------------ SPIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": ${setItemListElement}
              }
            `
          }}
        />

        {/* <img
              width='99999'
              height='99999'
              alt='background-default'
              title='background-default'
              className='background-default'
              style={{
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '99vw',
                height: '99vh',
                maxWidth: '99vw',
                maxHeight: '99vh'
              }}
              src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+'
            ></img> */}
      </Head>

      {!_.isEmpty(dataAffiliate) && <SectionAffiliate position={4} data={dataAffiliate} />}
      <Layout sessionSevId={sessionSevId}>
        {/* ---------------------------- ADS : LIGHTBOX ----------------------------- */}
        {/* {(lightBoxFilter && (lightBoxFilter.length > 0)) &&
        <div className={`light-box-ads ${!lightBox ? 'close' : 'open'}`}>
          <div className={`light-box`} onClick={handleLightBoxClick}>  */}
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.LIGHTBOX} data={ads} handler={() => handleLightBoxClick()} adsBox={adsBox} />}
        {/* </div>
        </div>} */}
        {/* ---------------------------- ADS : BILLBOARD ----------------------------- */}
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
        {/* {
          adsFinanceList.includes(sub) && <Ads
            adsClassName='ads'
            device='all'
            slot='/231599934,4696586/bangkokbiznews/Bitkub/billbord'
            position='div-gpt-ad-1641454399322-0'
            size={[[970, 250], [300, 250]]}
          />
        } */}
        {/* { adsEducationList.includes(sub) &&
          <div className='default-billboard'>
            {
              adsEducationList.includes(sub) && <Ads
                adsClassName='ads'
                device='all'
                slot='/231599934,4696586/bangkokbiznews/Social/billbord-Nida'
                position='div-gpt-ad-1643722284765-0'
                size={isTabletOrMobile ? [[336, 280], [300, 250]] : [[728, 90], [970, 250]]}
              />
            }
          </div>
        } */}
        <SectionWrapper id='section-1' className='category-wrapper' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
          <div className='container'>
            <ul className='breadcrumb'>
              <li>
                <a href='/'>หน้าแรก</a>
              </li>
              <li>{categoryNameTH}</li>
            </ul>

            <div className='row'>
              <div className='col-lg-8 col-md-12'>
                <h1 className='heading-title'>{categoryNameTH}</h1>
                <div className='row'>
                  {listArticles.length < 1 ? (
                    <div className='col-12 no-article'>
                      <img src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                    </div>
                  ) : (
                    <>
                      {/* <InfiniteScroll
                        className='infinite-scroll'
                        pageStart={0}
                        loadMore={handleLoad}
                        hasMore={true}
                        loader={<div className='fetching'> Loading... </div>}
                        threshold={2000}
                      // useWindow={false}
                      > */}
                      <div className='col-12'>
                        <SectionFullH
                          data={onTopArticle}
                          heading={false}
                          include={false}
                          txtSize={isRender('desktop') ? '--large' : '--small'}
                          ads={ads}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'ข่าวทั้งหมด',
                            position: 'ใต้:โฆษณาตำแหน่ง billboard',
                            data: {
                              block: '1',
                              heading: categoryNameTH
                            }
                          }}
                        />
                        <div className='row'>
                          {cloneListArticles.slice(0, show).map((item, index) => (
                            <div key={item.id} id={index + 1} className='col-6 col-md-4 mb-3'>
                              <CardV
                                data={item}
                                description={false}
                                badge={true}
                                path={item.link}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'ข่าวทั้งหมด',
                                  position: 'ใต้:โฆษณาตำแหน่ง billboard',
                                  data: {
                                    block: '1',
                                    title: item.title,
                                    heading: categoryNameTH,
                                    index: index + 6
                                  }
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                      <ButtonContainer>{loadData ? <text> Loading ... </text> : <button onClick={handleLoad}> ดูเพิ่มเติม</button>}</ButtonContainer>

                      {/* </InfiniteScroll> */}
                    </>
                  )}
                </div>
                <div id='postartice' className='ads-sticky-overflow'>
                  {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />}
                </div>
              </div>

              <div className='col-lg-4 col-md-12 d-lg-block d-none'>
                <StickyBox offsetTop={70} offsetBottom={70}>
                  {/* ---------------------------- ADS : STICKY-1 ----------------------------- */}

                  {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />}

                  <div className='widget-content'>
                    <div className='widget-content-title'>
                      <h3>ข่าวล่าสุด</h3>
                    </div>
                    <div className='block-content'>
                      {Array.isArray(lastNews) && lastNews.length < 1 ? (
                        <div className='no-article'>
                          <img className='--side' src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                        </div>
                      ) : (
                        <ul className='block-list'>
                          {lastNews.slice(0, 4).map((item, index) => (
                            <li key={index}>
                              <CardH
                                data={item}
                                large={false}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'ข่าวล่าสุด',
                                  position: 'ใต้:โฆษณาตำแหน่ง billboard',
                                  data: {
                                    block: '2',
                                    title: item.title,
                                    heading: 'ข่าวล่าสุด',
                                    index: index + 1
                                  }
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  {/* ---------------------------- ADS : STICKY-2 ----------------------------- */}
                  {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />}
                </StickyBox>
              </div>
            </div>
          </div>
        </SectionWrapper>
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    nextArticles: null,
    category: null,
    subCategory: null,
    lastNews: null,
    meta: null,
    ads: [],
    dataAffiliate: [],
    dataAdsHeader: null,
    backgroundImage: ''
  };
  const scriptBrowser = await GET('/api/headerAds');
  if (!_.isEmpty(scriptBrowser)) {
    initProps.dataAdsHeader = scriptBrowser || '';
  }
  const url = req.url;
  let uri = `categories/${rewriteTxt(query?.cid)}`;
  if (query.sub) {
    if (rewriteTxt(query?.sub) === 'latest-news') {
      uri = `categories/${rewriteTxt(query?.cid)}`;
    } else if (rewriteTxt(query?.cid) === 'latest-news') {
      uri = `categories/${rewriteTxt(query?.cid)}`;
    } else {
      uri = `categories/${rewriteTxt(query?.cid)}/${query?.sub}`;
    }
  } else if (url.startsWith('/tag')) {
    uri = `tag/${encodeURIComponent(query.cid)}`;
  }

  // console.log(uri, query);

  try {
    const regex = /([ก-๙])/;
    if (regex.test(query?.cid)) {
      res.setHeader('location', '/category/latest-news');
      res.statusCode = 301;
      res.end();
    }
    const resData = await GET_ARTICLES(`/api/v1.0/${uri}`, false, true);
    let resDataTo = null;

    if (resData?.statusCode === 404 || _.isUndefined(resData)) {
      return {
        redirect: {
          destination: '/',
          permanent: false
        }
      };
      // return {
      //   notFound: true
      // };
    }
    if (!_.isEmpty(resData)) {
      if (_.isEmpty(resData?.data)) {
        resDataTo = await GET_ARTICLES(`${resData?.nextTo}`, false, true);
        // console.log('#1', resDataTo);
        initProps.articles = resDataTo?.data || [];
      } else {
        initProps.articles = resData?.data || [];
      }
      initProps.nextArticles = resData?.nextTo || resData?.links?.next || null;
      initProps.category = resData?.category;
      initProps.subCategory = resData?.subCategory;
      initProps.lastNews = resData?.last_news || [];
      initProps.meta = resData.meta;
      initProps.ads = resData?.ads || [];
      initProps.dataAffiliate = resData?.affiliate || [];
      initProps.backgroundImage = resData?.category?.meta_data?.background || '';
    }
  } catch (err) {
    console.log('==========> CATEGORY ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }
  return {
    props: initProps
  };
}

export default PageCategory;

const ButtonContainer = styled.div`
  text-align: center;

  button {
    width: 100%;
    border: 1px solid #e3e3e3;
    background-color: #e3e3e3;
    color: #555555;
    border-radius: 5px;
    :hover {
      background-color: #0600E7;
      color: #fff;
      transition: background-color 1s linear;
    }
  }
`;
const SectionWrapper = styled.div`
  .empty-bg {
    background: unset !important;
  }
`;
